import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { apiClient } from '../api/client';

export function useVisitTracker() {
  const location = useLocation();

  useEffect(() => {
    // Track visit on location change
    const trackVisit = async () => {
      try {
        await apiClient.trackVisit(location.pathname);
      } catch (error) {
        console.error('Failed to track visit:', error);
      }
    };

    trackVisit();
  }, [location.pathname]);
}
